import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'horizontalGuidesForTablo',
    standalone: false
})
export class HorizontalGuidesForTabloPipe implements PipeTransform {
  transform(host: HTMLElement, scale: number): number[] {
    const hostBounding = host.getBoundingClientRect();

    return [hostBounding.y + hostBounding.height / 2];
  }
}
